import type { FC } from 'react';
import { Box, Typography } from '@mui/material';

import type { PillProps } from '../Pill/Pill';
import Pill from '../Pill/Pill';

interface WidgetHeaderWithPillProps {
  title: string;
  pillProps?: PillProps;
  ariaId: string;
}

const WidgetHeaderWithPill: FC<WidgetHeaderWithPillProps> = ({
  title,
  pillProps,
  ariaId,
}) => (
  <Box sx={{ display: 'flex', gap: 1 }}>
    <Typography variant="h5" id={ariaId}>
      {title}
    </Typography>
    {pillProps && <Pill {...pillProps} />}
  </Box>
);

export default WidgetHeaderWithPill;
